// src/components/About.js

import React from "react";
import "./About.css";

function About() {
  return (
    <section id="about" className="about-section">
      <h2>About Me</h2>
      <div className="about-content">
        <p>
          I’m <strong>Vivek Chary</strong>, a passionate <strong>Java Full Stack Developer</strong> 
          and <strong>Machine Learning Enthusiast</strong>. I enjoy solving real-world problems through
          coding and building modern, responsive web applications.
        </p>
        <p>
          I’m constantly learning new technologies and exploring how AI and software can make life easier.
          My goal is to create impactful solutions and grow as a full-stack developer.
        </p>
      </div>
    </section>
  );
}

export default About;
